import { SERVICES } from "@/be/services-dynamic";

export async function claimCleaner<TCommand>(result: bigint): Promise<void> {
  const { CMD } = await SERVICES();

  await CMD.deleteClaim({ id: result.toString() });
}

export async function productCleaner<TCommand>(result: bigint): Promise<void> {
  const { CMD } = await SERVICES();

  await CMD.deleteProduct({ id: result.toString() });
}
